import {
  type ButtonHTMLAttributes,
  type FC,
  forwardRef,
  type HTMLAttributes,
} from 'react';
import crossIcon from '@assets/img/icons/cross.svg';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import { Button } from '../Button/Button';

import css from './styles.module.scss';

const closeVariants = cva('', {
  variants: {
    variant: {
      modal: css.modal,
      outline: css.modal,
    },
    size: {
      sm: css.sm,
      base: css.base,
      lg: css.lg,
    },
  },
});

interface CloseProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof closeVariants> {
  imageVariant: 'modal' | 'outline';
  imageClassName?: string;
}

const Close: FC<CloseProps> = ({
  variant = 'modal',
  imageVariant,
  imageClassName,
  size = 'base',
  ...props
}) => {
  const img: Record<'modal' | 'outline', string> = {
    modal: crossIcon,
    // outline: modalCloseIconOutline,
    outline: crossIcon,
    // blured: bluredCloseIcon,
  };

  return (
    <Button
      {...props}
      className={cn(closeVariants({ variant, size }), props.className)}
      variant="transparent"
    >
      <img
        className={cn('w-[35%] aspect-square', imageClassName)}
        src={img[imageVariant]}
        alt="close"
      />
    </Button>
  );
};

const closeCircleVariants = cva('', {
  variants: {
    variant: {
      default: css.circleDefault,
    },
    cross: {
      default: css.circleCrossDefault,
    },
  },
});

interface CloseCircleProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof closeCircleVariants> {}

const CloseCircle = forwardRef<HTMLDivElement, CloseCircleProps>(
  ({ variant, cross, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(closeCircleVariants({ variant }), props.className)}
      >
        <span className={closeCircleVariants({ cross })}></span>
        <span className={closeCircleVariants({ cross })}></span>
      </div>
    );
  },
);

export { Close, CloseCircle };
